const contactFields = {
    connect_user_id: {
        type: 'input',
        label: 'Connect USER ID',
        validations: []
    },
    website_featured_image: {
        label: 'Website Featured Image',
        type: 'picture'
    },
    // Main Info
    first_name: {
        type: 'input',
        label: 'First Name',
        validations: ['min1','max50','no_numbers','required'],
        required: true
    },
    last_name: {
        type: 'input',
        label: 'Last Name',
        validations: ['min1','max50','no_numbers','required'],
        required: true
    },
    middle_initial: {
        type: 'input',
        label: 'Middle Initial',
        validations: ['max4','no_numbers']
    },
    illi_number: {
        type: 'input',
        label: 'illi #',
        validations: []
    },
    contact_type: {
        type: 'multi-select',
        options: ['Property Owner', 'Buyer', 'Lessee', 'Vendor',
        'Property Manager', 'Real Estate Agent', 'Real Estate Broker', 
        'Developer', 'illi Associate', 'illi Employee', 'Other'],
        keys: {
            'Property Owner': 'OWN',
            'Buyer': 'OTHER',
            'Tenant': 'OTHER',
            'Vendor': 'OTHER',
            'Property Manager': 'OTHER',
            'Real Estate Agent': 'REA',
            'Real Estate Broker': 'OTHER',
            'Developer': 'DEV',
            'Other': 'OTHER'
        }
    },
    dre: {
        label: 'DRE # - Agent',
        type: 'input',
        validations: ['max50']
    },
    dre_broker: {
        label: 'DRE # - Broker',
        type: 'input',
        validations: ['max50']
    },
    contact_type_other: {
        type: 'input',
        label: '',
        validations: ['max50']
    },
    contact_subtype: {
        type: 'multi-select',
        options: []
    },
    email: {
        type: 'input',
        label: 'Email',
        validations: ['min6','max100','email']
    },
    birthdate: {
        type: 'date',
        label: 'Birthdate'
    },
    use_type: {
        type: 'select',
        label: 'Company Type',
        options: []
    },
    desired_sqft_range: {
        type: 'select',
        label: 'Desired Sqft Range',
        options: [
            '0-1,500',
            '1,500-2,500',
            '2,500-5,000',
            '5,000-10,000',
            '10,000-25,000',
            '25,000-no max'
        ]
    },
    desired_price_range: {
        type: 'select',
        label: 'Desired Price/Value Range',
        options: [
            '0-$2,000,000',
            '$2,000,000-$5,000,000',
            '$5,000,000-$10,000,000',
            '$10,000,000-$25,000,000',
            '$25,000,000-no max'
        ]
    },
    salutation: {
        type: 'input',
        label: 'Salutation',
        validations: ['max50']
    },
    suffix: {
        type: 'input',
        label: 'Suffix',
        validations: ['max50']
    },
    spouse_first_name: {
        type: 'input',
        label: 'Spouse',
        validations: ['max50','no_numbers','no_special_chars']
    },
    title: {
        type: 'input',
        label: 'Title',
        validations: ['min1','max50']
    },
    website_url: {
        type: 'input',
        label: 'Website URL',
        validations: ['min1','max100']
    },
    department: {
        type: 'input',
        label: 'Department',
        validations: ['min1','max50']
    },
    // Phone Numbers
    assistant_phone: {
        type: 'input',
        label: 'Assistant Phone',
        validations: ['min10','max50']
    },
    fax: {
        type: 'input',
        label: 'Fax',
        validations: ['min10','max20']
    },
    home_phone: {
        type: 'input',
        label: 'Home Phone',
        validations: ['min10','max50']
    },
    main_phone: {
        type: 'input',
        label: 'Main Phone',
        validations: ['min10','max50']
    },
    mobile_phone: {
        type: 'input',
        label: 'Mobile Phone',
        validations: ['min10','max50']
    },
    other_phone: {
        type: 'input',
        label: 'Direct Phone',
        validations: ['min10','max50']
    },
    work_phone: {
        type: 'input',
        label: 'Work Phone',
        validations: ['min10','max50']
    },
    // Social Media 
    facebook: {
        type: 'input',
        label: 'Facebook',
        validations: ['max125']
    },
    twitter: {
        type: 'input',
        label: 'Twitter (X)',
        validations: ['max125']
    },
    linkedin: {
        type: 'input',
        label: 'Linkedin',
        validations: ['max125']
    },
    instagram: {
        type: 'input',
        label: 'Instagram',
        validations: ['max125']
    },
    // Preferences
    do_not_call: {
        type: 'select',
        label: 'Do Not Call',
        makeBinary: true,
        options: [{val:1,desc:'Yes'},{val:0,desc:'No'}]
    },
    looking_to_buy: {
        type: 'select',
        label: 'Looking to Buy?',
        makeBinary: true,
        options: [{val:1,desc:'Yes'},{val:0,desc:'No'}]
    },
    opted_out_of_email: {
        type: 'select',
        label: 'Opted Out of Email?',
        makeBinary: true,
        options: [{val:1,desc:'Yes'},{val:0,desc:'No'}]
    },
    preferred_contact_method: {
        type: 'select',
        label: 'Preferred Contact Method',
        options: ['Call', 'Text', 'Email', 'Mail']
    },
    price_range: {
        type: 'select',
        label: 'Price Range (Start and End)',
        options: ['$0-$5M', '$5M-$10M', '$10M-$15M', '$15M-$20M', '$20M-$30M', '$30M-$50M', '$50M-$100M', '$100M and up']
    },
    preferred_contact_time: {
        type: 'time_picker',
        label: 'Preferred Contact Start Time'
    },
    preferred_contact_endtime: {
        type: 'time_picker',
        label: 'Preferred Contact End Time'
    },
    category: {
        type: 'select',
        label: 'Category',
        options: ['New','Research','Verified']
    },
    // Information
    last_attempted_contact_date: {
        type: 'date',
        label: 'Last Attempted Contact Date'
    },
    last_contacted_date: {
        type: 'date',
        label: 'Last Contacted Date'
    },
    is_past_client: {
        type: 'select',
        label: 'Is Past Client?',
        makeBinary: true,
        options: [{val:1,desc:'Yes'},{val:0,desc:'No'}]
    },
    lead_source_category: {
        type: 'select',
        label: 'Lead Type',
        options: ['Apartments','Retail','Office','Industrial','Hospitality',
            'Self Storage']
    },
    lead_status: {
        type: 'select',
        label: 'Lead Status',
        options: ['New','Research','Verified']
    },
    email_bounced_reason: {
        type: 'input',
        label: 'Email Bounced Reason',
        validations: ['min1','max250']
    },
    lead_source: {
        type: 'input',
        label: 'Lead Source',
        validations: ['min1','max250']
    },
    lead_source_detail: {
        type: 'input',
        label: 'Lead Source Detail',
        validations: ['min1','max250']
    },
    notes: {
        type: 'input',
        label: 'Lead Source',
        validations: ['min1','max500']
    },
    referral_source: {
        type: 'input',
        label: 'Referral Source',
        validations: ['max250']
    },
    relocating_time_frame: {
        type: 'input',
        label: 'Relocating Time Frame',
        validations: ['max250']
    },
    assistant_email: {
        type: 'input',
        label: 'Assistant Email',
        validations: ['email','max100']
    },
    assistant_name: {
        type: 'input',
        label: 'Assistant Name',
        validations: ['max50']
    },
    company_name: {
        type: 'input',
        label: 'Company Name',
        validations: ['max50']
    },
    company_represented: {
        type: 'input',
        label: 'Company Representative',
        validations: ['max50']
    },
    ssn: {
        type: 'input',
        label: 'SSN',
        validations: ['min9']
    },
    air_exclusive_right_to_represent_buyer: {
        type: 'file',
        label: 'AIR Exclusive Right to Represent Buyer',
        validations: []
    },
    exclusive_right_to_represent_buyer: {
        type: 'select',
        label: 'Exclusive Right to Represent Buyer',
        options: ['No','Yes'],
        validations: ['required']
    },
    files: {
        type: 'array',
        label: 'Files'
    },
    w9: {
        label: 'W9 Upload'
    },
    mailing_street1: {
        label: 'Mailing Street 1'
    },
    mailing_street2: {
        label: 'Mailing Street 2'
    },
    mailing_city: {
        label: 'Mailing City'
    },
    mailing_state: {
        label: 'Mailing State'
    },
    mailing_zip: {
        label: 'Mailing Zip'
    }
}
export default contactFields;
export const partnerFields = {
    email: {
        type: 'input',
        label: 'Email',
        validations: ['email','max100']
    },
    first_name: {
        type: 'input',
        label: 'Firstname',
        validations: ['max50']
    },
    last_name: {
        type: 'input',
        label: 'Lastname',
        validations: ['max50']
    },
    phone: {
        type: 'input',
        label: 'Phone',
        validations: ['min10','max50','no_letters']
    },
    notes: {
        type: 'input',
        label: 'Notes',
        validations: ['min1','max500']
    }
};

export const addressFields = {
    fields: {
        name: {
            label: 'Name',
            validations: ['max50','no_numbers','no_special_chars']
        },
        company_name: {
            label: 'Company Name',
            validations: ['max50']
        },
        street1: {
            label: 'Address 1',
            validations: ['min5','max50']
        },
        street2: {
            label: 'Address 2',
            validations: ['min1','max50']
        },
        state: {
            label: 'State',
            options: [{"name":"Alabama","abbreviation":"AL"},{"name":"Alaska","abbreviation":"AK"},{"name":"Arizona","abbreviation":"AZ"},{"name":"Arkansas","abbreviation":"AR"},{"name":"California","abbreviation":"CA"},{"name":"Colorado","abbreviation":"CO"},{"name":"Connecticut","abbreviation":"CT"},{"name":"Delaware","abbreviation":"DE"},{"name":"Florida","abbreviation":"FL"},{"name":"Georgia","abbreviation":"GA"},{"name":"Hawaii","abbreviation":"HI"},{"name":"Idaho","abbreviation":"ID"},{"name":"Illinois","abbreviation":"IL"},{"name":"Indiana","abbreviation":"IN"},{"name":"Iowa","abbreviation":"IA"},{"name":"Kansas","abbreviation":"KS"},{"name":"Kentucky","abbreviation":"KY"},{"name":"Louisiana","abbreviation":"LA"},{"name":"Maine","abbreviation":"ME"},{"name":"Maryland","abbreviation":"MD"},{"name":"Massachusetts","abbreviation":"MA"},{"name":"Michigan","abbreviation":"MI"},{"name":"Minnesota","abbreviation":"MN"},{"name":"Mississippi","abbreviation":"MS"},{"name":"Missouri","abbreviation":"MO"},{"name":"Montana","abbreviation":"MT"},{"name":"Nebraska","abbreviation":"NE"},{"name":"Nevada","abbreviation":"NV"},{"name":"New Hampshire","abbreviation":"NH"},{"name":"New Jersey","abbreviation":"NJ"},{"name":"New Mexico","abbreviation":"NM"},{"name":"New York","abbreviation":"NY"},{"name":"North Carolina","abbreviation":"NC"},{"name":"North Dakota","abbreviation":"ND"},{"name":"Ohio","abbreviation":"OH"},{"name":"Oklahoma","abbreviation":"OK"},{"name":"Oregon","abbreviation":"OR"},{"name":"Pennsylvania","abbreviation":"PA"},{"name":"Rhode Island","abbreviation":"RI"},{"name":"South Carolina","abbreviation":"SC"},{"name":"South Dakota","abbreviation":"SD"},{"name":"Tennessee","abbreviation":"TN"},{"name":"Texas","abbreviation":"TX"},{"name":"Utah","abbreviation":"UT"},{"name":"Vermont","abbreviation":"VT"},{"name":"Virginia","abbreviation":"VA"},{"name":"Washington","abbreviation":"WA"},{"name":"West Virginia","abbreviation":"WV"},{"name":"Wisconsin","abbreviation":"WI"},{"name":"Wyoming","abbreviation":"WY"}]
        },
        city: {
            label: 'City',
            validations: ['no_numbers','no_special_chars']
        },
        zip: {
            label: 'Zipcode',
            validations: ['min5','max15','no_letters']
        },
        phone_number: {
            label: 'Phone Number',
            validations: ['max50','no_letters']
        },
        other_number: {
            label: 'Other Number',
            validations: ['min10','max50','no_letters']
        },
        fax: {
            label: 'Fax',
            validations: ['min10','max50','no_letters']
        },
        email: {
            label: 'Email',
            validations: ['email','min6','max100']
        }
    },
    types: {
        mailing: {
            fields: ['street1','street2','city','state','zip']
        },
        accounting: {
            fields: ['company_name','street1','street2','city','state','zip','email',
                    'phone_number','other_number','fax','name']
        },
        business: {
            fields: ['street1','street2','city','state','zip',
                    'phone_number']
        },
        legal: {
            fields: ['company_name','street1','street2','city','state','zip','email',
            'phone_number','other_number','fax','name']
        },
        property_management: {
            fields: ['company_name','street1','street2','city','state','zip','email',
            'phone_number','other_number','fax','name']
        },
        other: {
            fields: ['name','company_name','phone_number','fax',
                'street1','street2','city','state','zip','email']
        }
    }
}

const dataObj = {};
Object.keys(contactFields).forEach(field => {
    dataObj[field] = '';
})
dataObj.addresses = [];
dataObj.partners = [];
dataObj.appointments = [];
dataObj.files = [];
export const contactDataObj = dataObj;


const initialAddressDat = {
    mailing: {},
    accounting: {},
    business: {},
    legal: {},
    property_management: {},
    other: []
};

export const addTypeDict = {
    M: 'mailing',
    B: 'business',
    A: 'accounting',
    L: 'legal',
    P: 'property_management',
    O: 'other'
};

['mailing','accounting','business','legal','property_management'].forEach(addType => {
    if (addType !== 'other') {
        addressFields.types[addType].fields.forEach(f => {
            initialAddressDat[addType][f] = '';
        })
        initialAddressDat[addType].id = '';
    } else {
        initialAddressDat[addType] = [];
    }
});

export const initialAddressData = initialAddressDat;

export const otherAddressFields = {
    id: '',
    name: '',
    company_name: '',
    phone_number: '',
    fax: '',
    street1: '',
    street2: '',
    city: '',
    state: '',
    zip: '',
    email: ''
}

export const translateBinary = (dataObj) => {
    const newObj = { ...dataObj };
    Object.keys(contactFields).forEach(field => {
        
        if (contactFields[field].makeBinary) {
            if (newObj[field] === 'Yes') {
                newObj[field] = 1;
            } else {
                if (newObj[field] === 'No') {
                    newObj[field] = 0;
                } else {
                    newObj[field] = null;
                }
            }
        }
    })
    return newObj;
}


